import { render, staticRenderFns } from "./OpenAppPrompt.vue?vue&type=template&id=cdf3872a&scoped=true"
import script from "./OpenAppPrompt.vue?vue&type=script&lang=js"
export * from "./OpenAppPrompt.vue?vue&type=script&lang=js"
import style0 from "./OpenAppPrompt.vue?vue&type=style&index=0&id=cdf3872a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.21_css-loader@6.11.0_webpack@5.104.1_cssnano@5_665be98a8828166c9882e9000b2a540b/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdf3872a",
  null
  
)

export default component.exports